/* Source: /home/sidsolaiyappan/skooch_ai/shared/ai_profile_context.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { _aiDateToIso } from "./ai_message_helpers.js";
function _formatTimeHHMM(now) {
  let _h = now.getHours();
  let _m = now.getMinutes();
  let _hStr = ((_h < 10) ? ("0" + String(_h)) : String(_h));
  let _mStr = ((_m < 10) ? ("0" + String(_m)) : String(_m));
  return ((_hStr + ":") + _mStr);
}
function computeUpcomingDates(now) {
  let _aiToday = Reflect.construct(Date, [now.getFullYear(), now.getMonth(), now.getDate()]);
  let _dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  let _upcoming = {};
  let _todayDayIdx = ((_aiToday.getDay() + 6) % 7);
  let _nextWkStart = (7 - _todayDayIdx);
  let _offs = 0;
  while ((_offs < 14)) {
    let _d = Reflect.construct(Date, [_aiToday.getFullYear(), _aiToday.getMonth(), (_aiToday.getDate() + _offs)]);
    let _isoStr = _aiDateToIso(_d);
    let _dayIdx = ((_d.getDay() + 6) % 7);
    let _plainLabel = _dayNames.at(_dayIdx);
    if ((_offs === 0)) {
      _upcoming[(("today (" + _plainLabel) + ")")] = _isoStr;
      _upcoming[_plainLabel] = _isoStr;
    } else if ((_offs === 1)) {
      _upcoming[(("tomorrow (" + _plainLabel) + ")")] = _isoStr;
      if ((_upcoming[_plainLabel] === undefined)) {
        _upcoming[_plainLabel] = _isoStr;
      }
    } else {
      if ((_upcoming[_plainLabel] === undefined)) {
        _upcoming[_plainLabel] = _isoStr;
      }
    }
    if (((_offs >= _nextWkStart) && (_offs <= (_nextWkStart + 6)))) {
      if ((_upcoming[("next " + _plainLabel)] === undefined)) {
        _upcoming[("next " + _plainLabel)] = _isoStr;
      }
    }
    _offs = (_offs + 1);
  }
  return {"today_iso": _aiDateToIso(_aiToday), "current_time": _formatTimeHHMM(now), "upcoming": _upcoming};
}
function composeAiProfileContext(prefs, weekIsoDays, now) {
  let _u = computeUpcomingDates(now);
  return {"focus_peak": prefs["focus_peak"], "work_style": prefs["work_style"], "buffer_mins": prefs["buffer_mins"], "block_length": prefs["block_length"], "work_life_balance": prefs["work_life_balance"], "sleep_importance": prefs["sleep_importance"], "lock_personal_time": prefs["lock_personal_time"], "week_offset": prefs["week_offset"], "selected_day": prefs["selected_day"], "theme_dark": prefs["theme_dark"], "today_iso": _u["today_iso"], "current_time": _u["current_time"], "week_iso_days": weekIsoDays, "upcoming_dates": _u["upcoming"]};
}
export {_formatTimeHHMM, composeAiProfileContext, computeUpcomingDates};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:_formatTimeHHMM": {"is_writer": false, "touches": ["*"]}, "func:computeUpcomingDates": {"is_writer": false, "touches": ["*"]}, "func:composeAiProfileContext": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=ai_profile_context.js.map
